<div
  class="box-border round-bottom w-full bg-neutrals-0 border-neutrals-300 p-6"
>
  <div class="grid grid-cols-12 mb-4 gap-4">
    <div
      class="col-span-4 bg-[#E9EFFF] rounded text-center justify-between flex px-2 py-1 items-center h-[53px]"
    >
      <ui-paragraph
        type="p10"
        mobile-type="p10"
        textColor="primary-700'"
        font-weight="semibold"
      >
        Respuestas Rápidas:
      </ui-paragraph>
      <unicon-select
        [options]="quickAnswerType"
        [placeholder]="'Seleccionar'"
        [multiple]="false"
        [disabled]="false"
        [selectedValue]="selectedQuickAnswerType"
        (selectionChange)="setActiveAAnswerType($event)"
        class="w-[60%] custom-select-multimedia"
        [disabled]="isBlockedByAgent || isClosedLead"
      ></unicon-select>
    </div>
    <div
      class="items-center justify-center col-span-7 gap-4 flex transition-all duration-300 overflow-hidden"
      [ngClass]="{
        'h-[84px] overflow-y-auto': show,
        'h-[37px]': !show,
      }"
      *ngIf="isLoadingQuickAnswers"
    >
      <ui-loader type="primary" size="md" />
    </div>
    <div
      class="col-span-7 gap-4 flex flex-wrap transition-all duration-300 overflow-hidden"
      [ngClass]="{
        'h-[84px] overflow-y-auto': show,
        'h-[37px]': !show,
      }"
      *ngIf="!isLoadingQuickAnswers"
    >
      <button
        class="rounded-lg border-solid border-[1px] border-neutrals-300 px-3 py-2 text-center h-[33px] flex items-center justify-center"
        (click)="addQuickAnswerOnChat(answer)"
        *ngFor="let answer of quickAnswersList"
        [disabled]="!isActivated"
      >
        <ui-paragraph
          type="p10"
          mobile-type="p10"
          textColor="neutrals-600'"
          font-weight="regular"
        >
          {{ answer.type }}
        </ui-paragraph>
      </button>
    </div>
    <div class="col-span-1 flex items-center justify-center">
      <button type="button" (click)="show = !show">
        <ui-icon
          size="24"
          mSize="24"
          name="chevron-up"
          [attr.name]="!show ? 'chevron-down' : 'chevron-up'"
          fill="primary-600"
        ></ui-icon>
      </button>
    </div>
  </div>
  <div class="flex items-center">
    <form
      [formGroup]="chatForm"
      (ngSubmit)="onSubmit()"
      class="w-full flex flex-col gap-3"
      *ngIf="!(isClosedLead && !isBlockedByAgent)"
    >
      <div
        class="flex justify-between gap-6 px-5 py-[10px] h-auto min-h-[52px] box-border w-full rounded-[12px] items-center bg-neutrals-100"
      >
        <div
          *ngIf="visibleAudioRecording"
          [ngClass]="{ hidden: !isRecodingAudio }"
          class="grow flex justify-end gap-5"
        >
          <button
            class="hover:scale-105"
            type="button"
            (click)="deleteAudioRecording()"
          >
            <ui-icon name="delete" fill="neutrals-900" size="22" m-size="22" />
          </button>

          <unicon-audio-recording-field
            (audioRecordingStarted)="onInitAudioRecording()"
            (audioPermissionError)="onAudioPermissionError($event)"
            (audioFileRecorded)="onAudioRecorded($event)"
          />
        </div>

        <textarea
          *ngIf="!isRecodingAudio"
          #messageInput
          class="attach-file-input bg-transparent outline-none flex-grow w-full focus:outline-none resize-none h-[20px] overflow-y-auto"
          [ngClass]="{ hidden: isBlockedByAgent || isClosedLead }"
          type="text"
          [placeholder]="
            fullname ? 'Escribe un mensaje a ' + fullname : 'Escribe un mensaje'
          "
          formControlName="textMessage"
          (input)="autoResize(messageInput)"
          (keydown)="handleKeyDown($event)"
        ></textarea>

        <ui-paragraph
          *ngIf="isBlockedByAgent"
          class="flex-grow"
          type="p12"
          mobile-type="p12"
          font-weight="regular"
          text-color="neutrals-500"
        >
          Este chat está bloqueado porque está siendo atendido por {{ agent }}.
        </ui-paragraph>

        <div class="flex flex-row gap-3">
          <button
            class="hover:scale-110"
            type="button"
            (click)="initAudioRecord()"
            matTooltip="Grabar audio"
            *ngIf="!isRecodingAudio"
            [disabled]="isBlockedByAgent || isClosedLead || !isActivated"
          >
            <ui-icon
              name="microphone-outline"
              [attr.fill]="getFillColor()"
              size="24"
              m-size="24"
            />
          </button>
          <button
            class="hover:scale-110"
            type="button"
            (click)="attachFile.click()"
            matTooltip="Máximo 4 archivos"
            *ngIf="!isRecodingAudio"
            [disabled]="isBlockedByAgent || isClosedLead || !isActivated"
          >
            <ui-icon
              name="attach"
              [attr.fill]="getFillColor()"
              size="24"
              m-size="24"
            />
            <div class="w-0 h-0 invisible">
              <input
                type="file"
                #attachFile
                accept="image/jpeg, image/png, audio/aac, audio/ogg, audio/mp4, audio/amr, audio/mpeg, application/pdf, file/pdf, file/vnd.ms-excel, video/mp4, video/3gpp"
                (change)="onFileChange($event)"
                multiple="true"
              />
            </div>
          </button>

          <button
            class="hover:scale-110"
            type="button"
            matTooltip="Emoticones"
            *ngIf="!isRecodingAudio"
            [disabled]="isBlockedByAgent || isClosedLead"
          >
            <ui-icon
              name="face-happy"
              [attr.fill]="getFillColor()"
              size="24"
              m-size="24"
            />
          </button>

          <div *ngIf="isRecodingAudio" class="border-r border-[#D2DEF1]"></div>

          <button
            class="hover:scale-110"
            type="submit"
            matTooltip="Enviar"
            [disabled]="!canSendMessage"
          >
            <ui-icon
              name="send"
              [attr.fill]="getFillColor(true)"
              size="24"
              m-size="24"
            />
          </button>
        </div>
      </div>
      <div class="w-full flex gap-1" *ngIf="files.length > 0">
        <unicon-file-field
          *ngFor="let file of files"
          [file]="file"
          (delete)="onDeleteFile($event)"
        />
      </div>
    </form>
    <div
      *ngIf="isClosedLead && !isBlockedByAgent && !visibleMenu"
      class="bg-[#E8EDFD] rounded-xl px-5 py-4 flex items-center w-full justify-between"
    >
      <ui-paragraph
        class="flex-grow"
        type="p12"
        mobile-type="p12"
        font-weight="semibold"
        text-color="neutrals-700"
      >
        La conversación se cerró luego de 24 horas del último mensaje del
        usuario.
      </ui-paragraph>
      <button
        class="bg-[#FDDE2F] rounded-[6px] px-6 py-1"
        (click)="onReactivateChat()"
        [disabled]="!isActivated"
      >
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          text-color="neutrals-900"
          font-weight="semibold"
        >
          Reactivar
        </ui-paragraph>
      </button>
    </div>
    <div *ngIf="visibleMenu" class="dropdown-menu">
      <div class="flex justify-between mb-8">
        <ui-paragraph
          class="px-2"
          type="p18"
          mobile-type="p18"
          text-color="neutrals-900"
          font-weight="semibold"
        >
          Enviar Plantilla de WhatsApp
        </ui-paragraph>
        <button type="button" (click)="onCloseTemplateList()">
          <ui-icon name="close" size="20" m-size="20" fill="neutrals-900" />
        </button>
      </div>
      <mat-radio-group
        [(ngModel)]="selectedOption"
        color="primary"
        class="flex flex-col gap-2.5 overflow-y-auto max-h-[300px]"
        *ngIf="!visibleOptions"
      >
        <div
          class="rounded-2xl border-solid border-[1px] border-[#D2DEF1] p-4"
          *ngFor="let option of options"
          [value]="option"
        >
          <mat-radio-button [value]="option">
            <ui-paragraph
              class="px-2"
              type="p12"
              mobile-type="p12"
              text-color="neutrals-900"
              font-weight="semibold"
            >
              {{ option.name }}
            </ui-paragraph>
            <ui-paragraph
              class="px-2"
              type="p10"
              mobile-type="p10"
              text-color="neutrals-900"
              font-weight="semibold"
            >
              {{ option.message }}
            </ui-paragraph>
          </mat-radio-button>
        </div>
      </mat-radio-group>
      <div *ngIf="visibleOptions" class="flex items-center justify-center">
        <ui-loader type="primary" size="2xl" />
      </div>
      <div class="flex justify-end mt-7">
        <button
          class="bg-[#FDDE2F] rounded-[6px] px-6 py-3 flex justify-center gap-2 w-[140px]"
          (click)="selectedTemplate()"
        >
          <ui-icon
            *ngIf="!isLoading"
            name="send"
            m-size="20"
            size="20"
            fill="neutrals-900"
          />
          <ui-paragraph
            type="p12"
            mobile-type="p12"
            text-color="neutrals-900"
            font-weight="semibold"
            *ngIf="!isLoading"
          >
            Enviar
          </ui-paragraph>
          <ui-loader type="secondary" size="md" *ngIf="isLoading" />
        </button>
      </div>
    </div>
  </div>
</div>
